module.exports = __webpack_public_path__ + "img/waiting-back.8aa60839.svg";